

import moment from 'moment';

import { defineComponent } from 'vue';


export default defineComponent({
  name: "TimelineList",
  props: {
    title: {
      type: String,
      default: "",
    },
    rota: {
      type: Object,
      default: () => { {} },
    },
    description: {
      type: String,
      default: "",
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getRota(){
      if(!this.rota)return {};
      return this.rota
    }
  },
  methods: {
    toHora(date:any) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    },
    getDistance(rota:any) {
      if(!rota.Caminho)return 0;
      return (rota.Caminho.reduce((acc:any, item:any) => acc + item.distance, 0)).toFixed(2);
    }
  }
});
